export const CrownBig = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6L16 12L21 8L19 18H5L3 8L8 12L12 6Z" fill="#E69217" {...props} />
  </svg>
);
